
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-facilities-that-ship",
      function () {
        return require("private-next-pages/storage-facilities-that-ship/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-facilities-that-ship"])
      });
    }
  